var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('i',{staticClass:"icon el-icon-warning"}),_vm._v(" 试用版本仅支持试用部分功能，解锁全部功能请前往购买 "),_c('router-link',{staticClass:"right",attrs:{"to":{name:'goods'}}},[_vm._v("立即购买")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }